export default "__VITE_ASSET__WNR_0c13__"